export enum AccountType {
  COMPANY = 'company',
  INDIVIDUAL = 'individual',
}
